import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiEventManager } from 'ng-jhipster';

import { IScopeMySuffix } from 'src/app/shared/model/scope-my-suffix.model';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';
import { ScopeMySuffixService } from './scope-my-suffix.service';

@Component({
    selector: 'jhi-scope-my-suffix-delete-dialog',
    templateUrl: './scope-my-suffix-delete-dialog.component.html'
})
export class ScopeMySuffixDeleteDialogComponent {
    scope: IScopeMySuffix;

    constructor(private scopeService: ScopeMySuffixService, public activeModal: NgbActiveModal, private eventManager: JhiEventManager) {}

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.scopeService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'scopeListModification',
                content: 'Deleted an scope'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-scope-my-suffix-delete-popup',
    template: ''
})
export class ScopeMySuffixDeletePopupComponent implements OnInit, OnDestroy {
    private ngbModalRef: NgbModalRef;

    constructor(private activatedRoute: ActivatedRoute, private router: Router, private modalService: NgbModal,
    private languageChangeService: LanguageChangeService,
    ) {
        this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    }); 
    }

    ngOnInit() {
        this.activatedRoute.data.subscribe(({ scope }) => {
            setTimeout(() => {
                this.ngbModalRef = this.modalService.open(ScopeMySuffixDeleteDialogComponent as Component, {
                    size: 'lg',
                    backdrop: 'static'
                });
                this.ngbModalRef.componentInstance.scope = scope;
                this.ngbModalRef.result.then(
                    result => {
                        this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.ngbModalRef = null;
                    },
                    reason => {
                        this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.ngbModalRef = null;
                    }
                );
            }, 0);
        });
    }

    ngOnDestroy() {
        this.ngbModalRef = null;
    }
}
